export { default } from './SectionUnderstanding';